import PreviewWatermark from './PreviewWatermark.component';

export default PreviewWatermark;
